module.exports = __webpack_public_path__ + "img/gamcare.8ee6db87.svg";